if (!customElements.get("m-collection-list")) {
  class MCollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
        slideInner: ".m-mixed-layout__inner",
      };

      this.classes = {
        grid: "m:grid",
        hidden: "m:hidden",
        swiper: "swiper-container",
        swiperWrapper: "swiper-wrapper",
      };

      this.domNodes = queryDomNodes(this.selectors, this);

      this.slider = false;

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = parseInt(this.dataset.items, 10) || 4;
      this.total = parseInt(this.dataset.total, 10) || 0;
      this.mobileItems = parseFloat(this.dataset.mobileItems) || 1.5;

      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5;
      this.paginationType = this.dataset.paginationType;
      this.expanded = this.dataset.expanded === "true";
      this.mobileDisableSlider =
        this.dataset.mobileDisableSlider === "true";

      this.init();

      document.addEventListener("matchMobile", () => {
        this.init();
      });

      document.addEventListener("unmatchMobile", () => {
        this.init();
      });
    }

    init() {
      if (!this.enableSlider) return;

      if (
        MinimogTheme.config.mqlMobile &&
        this.mobileDisableSlider
      ) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const {
        slideContainer,
        slideControls,
        slideInner,
      } = queryDomNodes(this.selectors, this);

      if (!slideContainer || !slideInner) return;

      const prevButton =
        slideControls &&
        slideControls.querySelector(
          ".m-slider-controls__button-prev"
        );

      const nextButton =
        slideControls &&
        slideControls.querySelector(
          ".m-slider-controls__button-next"
        );

      const paginationElement =
        slideControls &&
        slideControls.querySelector(".swiper-pagination");

      const paginationIcon = `
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 72 72"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="time"
            stroke-width="5"
            fill="none"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="28"
          ></circle>
        </svg>
      `;

      const desktopItems = this.items;
      const tabletItems =
        desktopItems >= 3 ? 3 : desktopItems;

      this.options = {
        /*
         * 手机端固定显示 1.5 张。
         * 不再使用原来的 2 张和 480px 后 3 张。
         */
        slidesPerView: this.mobileItems,

        /*
         * 保留主题原生循环轮播逻辑。
         */
        loop: true,

        slidesPerGroup: 1,
        spaceBetween: 0,

        showNavigation: true,
        showPagination: true,

        parallax: true,
        autoHeight: true,

        allowTouchMove: true,
        simulateTouch: true,

        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
            }
          : false,

        pagination:
          this.paginationType === "fraction"
            ? {
                el: paginationElement,
                clickable: true,
                type: "fraction",
              }
            : {
                el: paginationElement,
                clickable: true,
                bulletClass: "m-dot",
                bulletActiveClass: "m-dot--active",
                renderBullet(index, className) {
                  return (
                    '<span class="' +
                    className +
                    '">' +
                    paginationIcon +
                    "</span>"
                  );
                },
              },

        navigation:
          nextButton || prevButton
            ? {
                nextEl: nextButton || null,
                prevEl: prevButton || null,
              }
            : false,

        breakpoints: {
          /*
           * 手机端 0–767px：
           * 一直保持 1.5 张。
           */

          768: {
            slidesPerView: tabletItems,
            slidesPerGroup: 1,
          },

          /*
           * 电脑端严格使用后台设置的数量。
           * 不再因为 Expanded 而增加一张。
           */
          1280: {
            slidesPerView: desktopItems,
            slidesPerGroup: 1,
          },
        },
      };

      if (typeof this.slider !== "object") {
        slideContainer.classList.add(this.classes.swiper);

        slideInner.classList.remove(this.classes.grid);
        slideInner.classList.add(this.classes.swiperWrapper);

        if (slideControls) {
          slideControls.classList.remove(this.classes.hidden);
        }

        this.slider = new MinimogLibs.Swiper(
          slideContainer,
          this.options
        );
      }
    }

    destroySlider() {
      const {
        slideContainer,
        slideControls,
        slideInner,
      } = queryDomNodes(this.selectors, this);

      if (!slideContainer || !slideInner) return;

      slideContainer.classList.remove(this.classes.swiper);

      slideInner.classList.remove(
        this.classes.swiperWrapper
      );

      slideInner.classList.add(this.classes.grid);

      if (slideControls) {
        slideControls.classList.add(this.classes.hidden);
      }

      if (typeof this.slider === "object") {
        this.slider.destroy(true, true);
        this.slider = false;
      }
    }
  }

  customElements.define(
    "m-collection-list",
    MCollectionList
  );
}